export const ENV_KEYS = {
    GEMINI_API_URL: 'REACT_APP_GEMINI_API_URL',
    GEMINI_API_KEY: 'REACT_APP_GEMINI_API_KEY',
    DENO_API_URL: 'REACT_APP_DENO_API_URL',
    WEB_APP_URL: 'REACT_APP_WEB_APP_URL',
    TRANSACTIONS_ENDPOINT: 'REACT_APP_TRANSACTIONS_ENDPOINT',
    PAGE_COUNT_ENDPOINT: 'REACT_APP_PAGE_COUNT_ENDPOINT'
} as const;